import React from "react";
import InsideUKImage from "../assets/img/card-images/private_mansion_blue.svg";
import OutsideUKImage from "../assets/img/card-images/planet_blue.svg";
import MainlandUKImage from "../assets/img/card-images/apartment_block_blue.svg";
import { getPhone } from "../helpers/ContentStateHelper";
import ChangeProfileCommon from "./ChangeProfileCommon";
import GeneralPages from "./GeneralPages";

const ChangeAddress = {
  Title: "Change my address",
  CurrentAddressTitle: "Your current address",
  labelAddressLine1: "Address line 1",
  labelAddressLineTown: "Town",
  labelAddressLineCounty: "County",
  labelAddressLinePostCode: "Postcode",
  LargeCorporateWarning:
    "We recommend you also ensure your company is made aware of this address change.",
  ValidationErrors: {
    EmptyAddressLine1: "Please enter the first line of your address",
    EmptyAddressLineTown: "Please enter your town",
    EmptyAddressLineCounty: "Please enter a county",
    EmptyAddressLinePostCode: "Please enter your postcode",
    InvalidFormatServerPostCode: "Please enter postcode in correct format",
    InvalidFormatPostCode: "Please enter a valid postcode",
    UpdateFailed:
      "An error occurred while updating your address. Please try again."
  },
  labelSelectAddress: "Please select where your new address is",
  TitleInsideUK: "in the united kingdom",
  TitleOutsideUK: "outside of the united kingdom",
  labelSelectUnitedKingdomAddress:
    "Please select where in the UK your new address is",
  TitleMainlandUK: "Mainland UK",
  DescMainlandUK: "In mainland England, Wales, Scotland, or Northern Ireland",
  TitleChannelIslands: "Channel Islands",
  DescChannelIslands: "In Jersey, Guernsey, or the Isle of Man",
  OutsideUkTooltipMessage: {
    Any: (props) => (
      <p>
        Sorry, as your address is outside of mainland UK, you'll need to give us
        a call on {getPhone(props)} to update your details.
      </p>
    )
  },
  ImageSource: {
    InsideUKImgSrc: InsideUKImage,
    OutsideUKImgSrc: OutsideUKImage,
    MainlandUKImgSrc: MainlandUKImage,
    ChannelIslandsImgSrc: MainlandUKImage
  },
  InfoBox: ChangeProfileCommon.InfoBox,
  BackButtonLabel: ChangeProfileCommon.BackButtonLabel,
  SubmitButtonLabel: ChangeProfileCommon.SubmitButtonLabel,
  InternalServerError: GeneralPages.InternalServerError,
  CorrectErrors: GeneralPages.CorrectErrors
};

export default ChangeAddress;
